localStorage.removeItem('mp_material_types');
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Ensure global tailwind object exists so inline scripts setting tailwind.config don't throw Uncaught ReferenceError
if (typeof window !== 'undefined' && !(window as any).tailwind) {
  (window as any).tailwind = { config: {} };
}

// Global fetch interceptor for force-logout on concurrent session detection
if (typeof window !== 'undefined') {
  try {
    const originalFetch = window.fetch;
    if (originalFetch) {
      const interceptedFetch = async (input: RequestInfo | URL, init?: RequestInit) => {
        const response = await originalFetch(input, init);
        if (response.status === 401) {
          try {
            const clone = response.clone();
            const data = await clone.json();
            if (data.error && data.error.includes('another device')) {
              console.warn('Force logout triggered: logged in on another device.');
              localStorage.removeItem('token');
              localStorage.removeItem('mcq_pulse_token');
              localStorage.removeItem('mcq_pulse_user');
              
              // Clear any cookie sessions
              const cookiesToClear = ['admin_session', 'session_id', 'csrf_token'];
              cookiesToClear.forEach(cookieName => {
                document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Strict;`;
              });

              // Redirect to lander with force_logout flag
              window.location.href = '/?force_logout=true';
            }
          } catch (e) {}
        }
        return response;
      };

      try {
        window.fetch = interceptedFetch;
      } catch (err) {
        try {
          Object.defineProperty(window, 'fetch', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: interceptedFetch
          });
        } catch (defineErr) {
          console.warn('Could not redefine fetch via Object.defineProperty', defineErr);
        }
      }
    }
  } catch (globalErr) {
    console.warn('Global fetch interceptor warning: fetch cannot be overridden in this environment.', globalErr);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

